import { request } from "../../api";

export type SignInProviderID = "google" | "microsoft" | "github";

export interface SignInProvider {
  id: SignInProviderID;
  enabled: boolean;
  clientId: string;
  hasSecret: boolean;
  callbackUrl: string;
  usesApp?: boolean;
}

export interface SignInConfig {
  configured: boolean;
  source: "saved" | "deployment" | "none";
  providers: SignInProvider[];
}

export interface SignInProviderInput {
  id: SignInProviderID;
  enabled: boolean;
  clientId: string;
  clientSecret?: string;
}

export const signInAdminApi = {
  config: () => request<SignInConfig>("/v1/admin/signin/providers"),
  save: (providers: SignInProviderInput[]) => request<SignInConfig>("/v1/admin/signin/providers", { method: "PUT", body: { providers } }),
};

export const signInAdminKeys = { config: ["admin", "signin-providers"] as const };
